// pixel constants for layouts

// Please see https://github.com/ridewithgps/rwgps-ui/pull/1328 for
// the full context on how we chose these threshold values for collapse
// behavior
export const CONTENT_COLLAPSE_WIDTH = 770
